/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-05-13 13:27:23
 * @LastEditors: wl
 * @LastEditTime: 2020-06-15 17:16:22
 */ 
import axios from '../axios'

/* 
 * 字典管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/admin/service/sys_dictionaries_add',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/admin/service/sys_dictionaries_remove',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/admin/service/sys_dictionaries_list',
        method: 'post',
        data
    })
}

//字典类型管理的数据/admin/service/sys_dictionariesType_list
export const findPageType = (data) => {
    return axios({
        url: '/admin/service/sys_dictionariesType_list',
        method: 'post',
        data
    })
}

//字典类型的新增/admin/service/sys_dictionariesType_add


export const saveType = (data) => {
    return axios({
        url: '/admin/service/sys_dictionariesType_add',
        method: 'post',
        data
    })
}
//删除和批量删除   /admin/service/sys_dictionariesType_remove

export const batchDeleteType = (data) => {
    return axios({
        url: '/admin/service/sys_dictionariesType_remove',
        method: 'post',
        data
    })
}


///登录的时候 初始化数据 admin/service/sys_dictionaries_array

export const initDict = (data) => {
    return axios({
        url: 'admin/service/sys_dictionaries_array',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dict.js